import axios from 'axios';

const secure_accesscode_key = process.env.REACT_APP_MS_API_KEY;

const sendSACCode = async (phoneNumber, type) => {
    let data = JSON.stringify({
        "to": "+1" + phoneNumber,
        "channel": type,
        "service": "addresschange"
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://microservices-fd-dtbtaqb0epdrdhf4.a01.azurefd.net/sac/send-twilio-code',
        headers: { 
            'Ocp-Apim-Subscription-Key': secure_accesscode_key, 
            'Content-Type': 'application/json'
        },
        data: data
    };

    console.log('[sendSACCode] Sending:', data);
    try {
        const response = await axios(config);
        console.log('[sendSACCode] Response:', response.status, response.data);
        // Optionally check for response status
        if (response.status >= 200 && response.status < 300) {
            return { success: true, data: response.data };
        } else {
            return { success: false, error: response.data || 'Unexpected response status' };
        }
    } catch (error) {
        console.log('[sendSACCode] Error:', error.response?.data || error.message || error);
        // You can extract more details if needed
        return { 
            success: false, 
            error: error.response?.data || error.message || 'Unknown error'
        };
    }
};
export { sendSACCode };

const verifySACCode = async (phoneNumber, code) => {
    let data = JSON.stringify({
        "to": "+1" + phoneNumber,
        "code": code,
        "service": "addresschange"
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://microservices-fd-dtbtaqb0epdrdhf4.a01.azurefd.net/sac/verify-twilio-code',
        headers: { 
            'Ocp-Apim-Subscription-Key': secure_accesscode_key, 
            'Content-Type': 'application/json'
        },
        data: data
    };

    try {
        const response = await axios.request(config);
        console.log('[verifySACCode] Response:', response.status, response.data);
        return response.data;
    } catch (error) {
        console.log('[verifySACCode] Error:', error.response?.data || error.message || error);
        return error;
    }
}
export { verifySACCode };